import React, { memo } from 'react';

import { Select } from '../../components';
import { templates } from '../constants';

const options = [
  { id: templates.DAO, name: 'DAO Watches' },
  { id: templates.NO_LOGO, name: 'No Logo' },
];

export const CoverSettings = memo(function CoverSettings({
  template,
  setTemplate,
  lookbookName,
  setLookbookName,
  lookbookDate,
  setLookbookDate,
}) {
  return (
    <div className="lb-cover-settings">
      <div className="lb-cover-settings__field">
        <label className="cover-subtitle" htmlFor="lb-cover-template">
          Choose Template:
        </label>
        <div className="templates">
          <Select
            {...{
              className: 'select-container',
              options,
              onSelectionChange: (tmplt) => setTemplate(tmplt),
              field: { name: 'template', value: template },
              form: { setFieldValue: () => {} },
            }}
          />
        </div>
      </div>

      <div className="lb-cover-settings__row">
        <div className="lb-cover-settings__field">
          <label className="cover-subtitle" htmlFor="lb-cover-name">
            Lookbook Name:
          </label>
          <input
            id="lb-cover-name"
            type="text"
            value={lookbookName}
            onChange={(e) => setLookbookName(e.target.value)}
            placeholder="Lookbook name"
          />
        </div>

        <div className="lb-cover-settings__field">
          <label className="cover-subtitle" htmlFor="lb-cover-month">
            Publication Month:
          </label>
          <input
            id="lb-cover-month"
            type="text"
            value={lookbookDate}
            onChange={(e) => setLookbookDate(e.target.value)}
            placeholder="Publication month"
          />
        </div>
      </div>
    </div>
  );
});
